module.exports = __webpack_public_path__ + "static/img/avatar.3794c733.png";